// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 投放管理
 */
import Plan from '@/views/release/plan';
import Detailed from '@/views/release/detailed';
/**
 * 上下游管理
 */
import Advertlist from '@/views/control/advertlist';
import Dispose from '@/views/control/dispose';
import Channellist from '@/views/control/channellist';
/**
 * 数据报表
 */
import Census from '@/views/dataReport/census';
/**
 * 请求明细
 */
import Record from '@/views/detailed/record';
import DataDetail from '@/views/detailed/dataDetail';
/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 模块管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 角色管理-数据权限
import RolePower from '@/views/system/RolePower';

// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [
            {
                path: '/release/plan',
                name: '投放管理',
                component: Plan,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/release/detailed',
                name: '投放明细',
                component: Detailed,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/control/advertlist',
                name: '广告列表',
                component: Advertlist,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/control/dispose',
                name: '接口配置',
                component: Dispose,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/control/channellist',
                name: '渠道管理',
                component: Channellist,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/dataReport/census',
                name: '日报统计',
                component: Census,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/detailed/record',
                name: '排重记录',
                component: Record,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/detailed/dataDetail',
                name: '明细数据',
                component: DataDetail,
                meta: {
                    requireAuth: true
                }
            },  {
                path: '/system/user',
                name: '用户管理',
                component: user,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/Module',
                name: '模块管理',
                component: Module,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/Role',
                name: '角色管理',
                component: Role,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/RolePower',
                name: '数据权限',
                component: RolePower,
                meta: {
                    requireAuth: true
                }
            }]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js